import { TmcContextService } from './../../../../../common/tmc-context.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { SacClientContext } from '../../model/sac-client.context';
import { SacSelection, SacStructure } from '../../model/sac-client.model';
import { AppFrameContextService, CommonBrowserStorageService, DashboardContext } from '@sdbn/common';
import { StationGroup } from '../../../../../client/model/station-group';
import { StationSet } from '../../../../../client/model/station-set';
import { Station } from '../../../../../client/model/station';

@Component({
    selector: 'app-sac-stations',
    templateUrl: './sac-stations.component.html',
    styleUrls: ['./sac-stations.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SacStationsComponent implements OnInit {

  componentId = 'sac-stations';

  stationGroups = new Array<StationGroup>();

  sacClientContext: SacClientContext;

  selection: SacSelection;

  @Input() dashboardContext: DashboardContext;

  @Input('sacClientContext') set setSacClientContext(sacClientContext: SacClientContext) {
    this.sacClientContext = sacClientContext;
  }

  sacStructure: SacStructure;
  @Input('sacStructure') set setSacStructure(value: SacStructure) {

    console.log('setting structure', value);
    this.sacStructure = value;

    // TODO prüfen ob es eine gespeicherte selektion gibt
    this.loadSelectionFromBrowserStorage(value);

    // Sonst neue selektion festlegen (erster knoten)
    if (this.selection == null) {
      this.selectFirst(value);
    }

  }

  constructor(
    private tmcContextService: TmcContextService,
    private commonBrowserStorageService: CommonBrowserStorageService,
    private appFrameContextService: AppFrameContextService
  ) {

    this.tmcContextService.updated.subscribe(
      yardConfiguration => {
        if (yardConfiguration != null) {
          this.stationGroups = yardConfiguration.stationGroups;
        }
      }
    );
  }

  @Output() selectionChanged = new EventEmitter<SacSelection>();

  ngOnInit() { }

  // setSelectedStation(stationSet: StationSet, station: Station) {
  //   this.onSelectionChanged.next(new StationSelection({ station: station, stationSet: stationSet }));

  // }

  clickStation(stationSet: StationSet, station: Station) {

    this.selection = new SacSelection({ stationSet: stationSet, station: station });
    this.selectionChanged.next(this.selection);

    this.writeSelectionToBrowserStorage(this.sacStructure);

  }

  loadSelectionFromBrowserStorage(structure: SacStructure) {

    if (structure == null) {
      return;
    }

    console.log('loading selection from storage', structure);

    const storedSelection = JSON.parse(this.commonBrowserStorageService.get(this.appFrameContextService.tenant.value.key, this.componentId, this.getStorageKey(structure)));
    if (storedSelection != null) {
      let selection = new SacSelection({
        stationSet: this.tmcContextService.findStationSetById(storedSelection.stationSetId),
        station: this.tmcContextService.findStationById(storedSelection.stationId)
      });
      this.selection = selection;
      this.selectionChanged.next(this.selection);
      console.log('restoring selection', selection);
    }
  }

  writeSelectionToBrowserStorage(structure: SacStructure) {
    this.commonBrowserStorageService.setPersistent(this.appFrameContextService.tenant.value.key, this.componentId, this.getStorageKey(structure), JSON.stringify({ stationSetId: this.selection.stationSet?.id, stationId: this.selection.station?.id }));
  }

  private selectFirst(structure: SacStructure) {

    console.log('selecting first', structure);

    let stationSet = null;
    if (structure.stationGroup != null) {
      stationSet = structure.stationGroup.stationSets[0];
    } else {
      stationSet = structure.stationSet;
    }
    this.clickStation(stationSet, stationSet.stations[0]);

  }

  private getStorageKey(structure: SacStructure): string {
    let result = 'selection';
    if (structure.stationGroup != null) {
      result += '-' + structure.stationGroup.id;
    }
    if (structure.stationSet != null) {
      result += '-' + structure.stationSet.id;
    }
    return result;
  }

}
